import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/trainer/trainer.css";
import "../../styles/home/home.css";
import "../../styles/trainer-member/trainer-member.css";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchTrainerNotificationLogsData } from "../../redux/incentives-reducers/incentivesSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import TrainerNotificationLogsTable from "../../components/trainer-report/trainer-notification-logs/TrainerNotificationLogsTable";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const TrainerNotificationLogs = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const dispatch = useDispatch();
  const { trainerNotificationLogs, trainerNotificationLogsLoading } =
    useSelector((state) => state.incentives);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(user);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : "",
    selectedTrainer: "",
    isActive: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: !isAdmin ? user?.gym_id || user?.uid || user?.user_id : "",
    trainer_id: "",
    status: "",
    start_date: "",
    end_date: "",
    search: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        search: allFilters.searchString,
      }));
    }
  };

  function getTrainerNotificationLogs(filters) {
    dispatch(
      fetchTrainerNotificationLogsData({
        filters: filters,
        token: user?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isManagerRole
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : "",
    }));
  }, [user?.gym_id]);

  useEffect(() => {
    const nonAdmin = user?.account_type !== "admin";

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: nonAdmin
        ? user.gym_id || user?.uid
        : allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      status: allFilters.isActive?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.isActive,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    user.gym_id,
  ]);

  useEffect(() => {
    getTrainerNotificationLogs(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Trainer Notification Logs">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading="Trainer Notification Logs"
              isReload={() => getTrainerNotificationLogs(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="trainer-notification-logs"
              userInfoData={user}
              onClickReset={onClickReset}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={trainerNotificationLogsLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TrainerNotificationLogsTable
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              trainerNotificationLogs={trainerNotificationLogs}
              trainerNotificationLogsLoading={trainerNotificationLogsLoading}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TrainerNotificationLogs;
